export const register = {
  title: "Inscription gratuite",
  email_label: "Email",
  password_label: "Mot de passe",
  pack_label: "Pack ID",
  company_name_label: "Nom de la société",
  owner_name_label: "Nom du gérant",
  phone_label: "Téléphone",
  rib_label: "RIB",
  kbis_label: "Télécharger le fichier KBIS",

  email_required: "Email requis",
  email_invalid: "Email invalide",
  password_required: "Mot de passe requis",
  pack_required: "Pack requis",
  company_name_required: "Nom de société requis",
  owner_name_required: "Nom du gérant requis",
  phone_required: "Téléphone requis",
  rib_required: "RIB requis",
  kbis_required: "KBIS requis",

  already_account: "Vous avez déjà un compte ?",
  login: "Connectez-vous",
  next: "Suivant",
  loading: "En cours...",
  address_label: "Adresse",
  address_required: "L'adresse est requise",

  urssaf_label: "urssaf",
  fiscale_label: "attestation de régularisation fiscale",
  rcPro_label: "rcpro",
  fichier_label: "selectionnez fichier",
  addFile: "Ajouter fichier",
  title_file: "Titre du fichier",
  alert_pack: "Vous devez sélectionner le pack",
};
